// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {FetchOrganizerCancellationSuccess} from 'redux/v1/organizerCancellation/actions';
import type {OrganizerCancellation} from 'redux/v1/organizerCancellation/models';
import type {OrganizerCancellationState} from 'redux/v1/organizerCancellation/OrganizerCancellationState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {
  DELETE_ORGANIZERCANCELLATION,
  FETCH_ORGANIZERCANCELLATION,
  PUT_ORGANIZERCANCELLATION,
} from 'redux/v1/organizerCancellation/actions';
import {organizerCancellationState} from 'redux/v1/V1State';

export const initialState: OrganizerCancellationState = {
  loading: false,
};

const actionCreators: ActionHandlers<OrganizerCancellationState> = {
  [PENDING(FETCH_ORGANIZERCANCELLATION)]: (
    state: OrganizerCancellationState
  ) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(FETCH_ORGANIZERCANCELLATION)]: (
    state: OrganizerCancellationState,
    action: FetchOrganizerCancellationSuccess
  ) => ({
    ...state,
    loading: false,
    data: action.data,
  }),
  [ERROR(FETCH_ORGANIZERCANCELLATION)]: (
    state: OrganizerCancellationState,
    action: any
  ) => ({
    ...state,
    loading: false,
    error: action.error,
  }),
  [SUCCESS(PUT_ORGANIZERCANCELLATION)]: (
    state: OrganizerCancellationState,
    action: FetchOrganizerCancellationSuccess
  ) => ({
    ...state,
    loading: false,
    data: {
      ...state.data,
      selected: true,
    },
  }),
  [SUCCESS(DELETE_ORGANIZERCANCELLATION)]: (
    state: OrganizerCancellationState,
    action: FetchOrganizerCancellationSuccess
  ) => ({
    ...state,
    loading: false,
    data: {
      ...state.data,
      selected: false,
    },
  }),
};

export const organizerCancellationReducer: Reducer<OrganizerCancellationState> = // $FlowIgnore
  createReducerUsingActionHandlers<OrganizerCancellationState>(
    initialState,
    actionCreators
  );

export const isOrganizerCancellationLoaded: Selector<boolean> = createSelector(
  organizerCancellationState,
  (state: OrganizerCancellationState) =>
    !state.loading && state.data !== undefined
);

export const getOrganizerCancellation: Selector<OrganizerCancellation> =
  createSelector(
    organizerCancellationState,
    (state: OrganizerCancellationState) => state.data ?? state.error
  );
